<template>
  <div>
    <!-- 기본으로 쓰는 백오피스 상품 등록페이지 -->
    <basic-product-reg v-if="!isLaunchpack"></basic-product-reg>
    <!-- 마스터 백오피스 상품 등록페이지 -->
    <launchpack-product-reg v-if="isLaunchpack"></launchpack-product-reg>
  </div>
</template>

<script>

  import BasicProductReg from "./BasicProductReg";
  import LaunchpackProductReg from "./LaunchpackProductReg";

  export default {
    layout: 'Main',
    components: {
      LaunchpackProductReg,
      BasicProductReg

    },
    watch:{

    },
    created() {
      this.getPackages();
    },
    data() {
      return {
        packages: []
      }
    },
    methods: {
      getPackages(){
        this.packages = this.$store.getters.getPackages;
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
